import { LoginTemplate } from '../templates'

export const LoginPage = () => {
  return (
    <LoginTemplate />
  )
}